import { render } from "./UiBadge.vue?vue&type=template&id=3a1e21d5"
import script from "./UiBadge.vue?vue&type=script&lang=js"
export * from "./UiBadge.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__